const selector = "[data-click-stop-propagation]"

document.addEventListener("DOMContentLoaded", (e) => {
  document.querySelectorAll(selector).forEach((element) => {
    element.addEventListener("click", (event) => {
      event.stopPropagation()
    })
  })
})
